const value = {
    nameTitle: 'Product/project name',
    nameSubtitle: 'This field should contain product/project name.',
    idTitle: 'Product/project ID',
    idSubtitle:
      'This field can be populated with a product or project ID. If the product or project does not have an ID, leave the field blank.',
    jiraLinkTitle: 'Link to the project in Jira',
    jiraLinkSubtitle: 'Copy and paste the project link into Jira.',
    summaryTitle: 'Summary',
    summarySubtitle: 'Any additional project info.',
  };

export default value;
